<template>
  <v-dialog v-model="dialog" persistent width="500">
    <v-card>
      <!-- Cabecera del formulario -->
      <v-card-title class="headline">
        <v-flex xs9>
          <v-icon>save</v-icon>
          {{ titulo_dialog }}
        </v-flex>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="close(false)" :loading="loading">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-form @submit.prevent="save" v-model="valid" ref="form" lazy-validation>
        <v-card-text class="px-2">
          <v-layout row wrap class="text-xs-center blue--text">
            <v-flex xs12>
              <v-text-field
                class="text-field-reducido-border"
                v-model="form.justificacion"
                :rules="$validate(['required'])"
                required
                label="Justificación*"
                outline
                clearable
              />
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <small class="error--text text-required"
            >* Los campos son obligatorios</small
          >
          <v-spacer></v-spacer>
          <v-btn @click.native="close(false)" :loading="loading">
            <v-icon>cancel</v-icon> {{ $t("common.cancel") }}
          </v-btn>
          <v-btn
            color="primary"
            type="submit"
            :loading="loading"
            :disabled="!valid"
          >
            <v-icon dark>check</v-icon> {{ $t("common.save") }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate";
export default {
  mixins: [validate],
  // Variables iniciales
  data() {
    return {
      valid: true,
      form: {},
      dialog: false,
      loading: false,
      user: this.$storage.get("user"),
      data_marcados: [],
      cierre: null,
      fecha_marcado: null,
      id_persona: null,
      titulo_dialog: null
    };
  },
  mounted() {
    this.$bus.$on("openDialogAbrirCerrarTipificacionDia", item => {
      this.data_marcados = item.marcados || [];
      this.cierre = item.cierre;
      this.fecha_marcado = item.fecha_marcado;
      this.id_persona = item.id_persona;
      this.titulo_dialog = item.titulo_dialog;
      this.dialog = true;
    });
  },
  methods: {
    // Metodo para cerrar la planilla
    async save() {
      try {
        if (!this.$refs.form.validate()) {
          return;
        }
        this.$confirm("¿Está seguro de guardar el ajuste?", async () => {
          this.loading = true;
          if (this.data_marcados.length > 0) {
            // Guardamos los marcados
            let res = await this.$service.graphql({
              query: `
                mutation edit($marcados: [AjusteMarcados]!,$id_usuario: Int!){
                  ajusteTipificacion(marcados: $marcados,id_usuario:$id_usuario){
                    mensaje
                  }
                }
              `,
              variables: {
                marcados: this.data_marcados,
                id_usuario: this.user.id
              }
            });
          }
          let sw_cierre = await this.verificaCierreDia();
          if (sw_cierre.valida) {
            // Modificamos el cierre
            await this.$service.graphql({
              query: `
                  mutation edit($id: ID!, $cierre_control_asistencia: EditCierreControlAsistencia!) {
                    cierreControlAsistenciaEdit(id: $id, cierre_control_asistencia: $cierre_control_asistencia) {
                      id
                    }
                  }
                `,
              variables: {
                id: parseInt(sw_cierre.id),
                cierre_control_asistencia: {
                  cerrado: this.cierre,
                  descripcion: this.form.justificacion,
                  _user_updated: this.user.id
                }
              }
            });
          } else {
            // Creamos el cierre
            await this.$service.graphql({
              query: `
								mutation add($cierre_control_asistencia: NewCierreControlAsistencia!){
									cierreControlAsistenciaAdd(cierre_control_asistencia: $cierre_control_asistencia){
										id
									}
								}
							`,
              variables: {
                cierre_control_asistencia: {
                  cerrado: this.cierre,
                  id_persona: this.id_persona,
                  fecha_marcado: this.fecha_marcado,
                  descripcion: this.form.justificacion,
                  id_estado: 1,
                  _user_created: this.user.id
                }
              }
            });
          }
          // Guardamos el seguimiento
          await this.$service.graphql({
            query: `
								mutation add($seguimiento_control_asistencia: NewSeguimientoControlAsistencia!){
									seguimientoControlAsistenciaAdd(seguimiento_control_asistencia: $seguimiento_control_asistencia){
										id
									}
								}
							`,
            variables: {
              seguimiento_control_asistencia: {
                id_persona: this.id_persona,
                fecha_marcado: this.fecha_marcado,
                cerrado: this.cierre,
                motivo: this.form.justificacion,
                id_estado: 1,
                _user_created: this.user.id
              }
            }
          });

          this.close(true);
          this.loading = false;
          this.$message.success();
        });
      } catch (error) {
        console.log(error);
      }
    },
    // Metodo para verifcar si ya existe o no el cierre del dia de marcado
    async verificaCierreDia() {
      try {
        let rpta = await this.$service.graphql({
          query: `
             query{
              cierreControlAsistencias(id_persona:${this.id_persona},fecha_marcado:"${this.fecha_marcado}"){
                rows{
                  id
                  fecha_marcado
                }
              }
            }
            `
        });
        if (rpta.cierreControlAsistencias.rows.length > 0) {
          return { valida: true, id: rpta.cierreControlAsistencias.rows[0].id };
        } else {
          return { valida: false };
        }
      } catch (error) {
        console.log(error);
      }
    },

    close(recargar) {
      this.loading = false;
      this.dialog = false;
      this.form={}
      if (recargar) {
        this.$bus.$emit("closeDialogAbrirCerrarTipificacionDia");
      }
    }
  }
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/admin/tipificacion/dialogs/AbrirCerrarTipificacionDia.vue